'use client'

import {
  IconAlertCircleYellow,
  IconArrowLeft,
} from '@macarongfactory/web-icons'
import { Text } from '@macarongfactory/web-ui'
import { useRouter } from 'next/navigation'

import { useIsInApp } from '../_features/modoocar'

/** 경고 아이콘 크기(px) — Figma Result 이미지 */
const ICON_SIZE_PX = 48
/** 앱바 높이·아이콘 크기 — InAppTopBar와 동일 (Figma 9064:34381) */
const APP_BAR_HEIGHT_PX = 56
const BACK_ICON_SIZE_PX = 24
const BACK_BUTTON_SIZE_PX = 44

const TITLE = '커스텀 차량은 모두의 차고 서비스가 제공되지 않아요'
const SUBTITLE = '내 차 정보에서 모델 차량을 다시 선택해주세요.'

/**
 * 커스텀(임의 추가)·미지원 차종 예외 화면
 * - 인앱: 뒤로가기(←) 앱바(56px) + 본문 Result (Figma 9064:34381)
 * - 웹: 본문만 (검색 헤더·탭은 미노출)
 */
const CustomVehicleNotice = () => {
  const isInApp = useIsInApp()
  const router = useRouter()

  return (
    <div className='flex min-h-[100dvh] flex-col bg-background-surface-default'>
      {/* 인앱: 뒤로가기 앱바 — 제목·검색 없음 (Figma Title HIDDEN, Trailing HIDDEN) */}
      {isInApp ? (
        <header
          className='flex shrink-0 items-center px-dimension-x1 py-[6px]'
          style={{ height: APP_BAR_HEIGHT_PX }}
        >
          <button
            type='button'
            aria-label='이전 화면으로 이동'
            onClick={() => router.back()}
            className='flex items-center justify-center'
            style={{
              width: BACK_BUTTON_SIZE_PX,
              height: BACK_BUTTON_SIZE_PX,
            }}
          >
            <IconArrowLeft
              width={BACK_ICON_SIZE_PX}
              height={BACK_ICON_SIZE_PX}
              className='text-foreground-neutral-strong'
            />
          </button>
        </header>
      ) : null}

      <div className='flex flex-1 flex-col items-center justify-center gap-dimension-x4 px-dimension-x5'>
        <IconAlertCircleYellow width={ICON_SIZE_PX} height={ICON_SIZE_PX} />
        <div className='flex flex-col items-center gap-dimension-x2'>
          <Text
            as='h1'
            variant='heading-3-semibold'
            color='text-foreground-neutral-strong'
            className='whitespace-pre-line break-keep text-center'
          >
            {TITLE}
          </Text>
          <Text
            variant='body-1-medium'
            color='text-foreground-neutral-normal'
            className='text-center'
          >
            {SUBTITLE}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default CustomVehicleNotice
